import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { getCompanyProducts } from '../../../../crud/product.crud';
import { getResponseMessage } from '../../../../utils/utils';
import { IProduct } from '../../../../interfaces/product';
import { actions as productCatalogActions } from '../../../../store/ducks/product-catalog.duck';

export const useGetProductsCompany = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState<IProduct[] | null>([]);
  const [page, setPage] = useState({ page: 1, perPage: 20, total: 0 });

  const fetch = useCallback(
    async ({
      id,
      data,
    }: {
      id: number;
      data: {
        page?: number;
        per_page?: number;
        locale?: string;
        category_id?: number;
      };
    }) => {
      setLoading(true);
      dispatch(productCatalogActions.setCategoryIdActive(data.category_id || 0));
      getCompanyProducts({ id, data })
        .then((res: any) => {
          // dispatch(productCatalogActions.setCategoryIdActive(data.category_id || 0));
          setProducts(res.data.data);
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const { page, per_page, total } = res.data;
          setPage({ page, perPage: per_page, total });
        })
        .catch(e => {
          enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
            variant: 'error',
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
    []
  );

  return { fetch, loading, products, page };
};
